// extracted by mini-css-extract-plugin
export default {"switchWrapper":"switch_switchWrapper__eQYBP","sun":"switch_sun__FCACd","moon":"switch_moon__WOr9m"};